import { render, staticRenderFns } from "./WebBodyFatScalesLog.vue?vue&type=template&id=d154d1aa&scoped=true&"
import script from "./WebBodyFatScalesLog.vue?vue&type=script&lang=js&"
export * from "./WebBodyFatScalesLog.vue?vue&type=script&lang=js&"
import style0 from "./WebBodyFatScalesLog.vue?vue&type=style&index=0&id=d154d1aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d154d1aa",
  null
  
)

export default component.exports